export default "__VITE_ASSET__CdQhyjaZ__"